

import { APP_CONFIG } from 'app-config';
import {
  EVMAssetInfo,
  EVMChainId,
  EVMChainInfo,
  EVMChainInfoDefinition,
} from './evm.types';

export const EVM_CHAINS_LIST = [
  // testnets

  {
    chainNetwork: 'testnet',
    type: 'evm',
    chainId: '11155111',
    chainName: 'Sepolia',
    rpcURL: 'https://eth-sepolia.public.blastapi.io',
    chainLogo: '/tokens/eth.svg',
    explorerURL: {
      home: 'https://sepolia.etherscan.io',
      transaction: 'https://sepolia.etherscan.io/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ETH',
        coinMinimalDenom: 'eth-wei',
        coinDecimals: 18,
        coinGeckoId: 'ethereum',
        coinImageUrl: '/tokens/eth.svg',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        contractAddress: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
        coinDenom: 'USDC',
        coinMinimalDenom: 'uusdc',
        coinDecimals: 6,
        coinGeckoId: 'usd-coin',
        coinImageUrl: '/tokens/usdc.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canDeposit: true,
        /**
         * Disabling Ethereum USDC withdrawals for the time being because
         * withdrarwals must go through Noble first.
         */
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },

  {
    chainNetwork: 'testnet',
    type: 'evm',
    chainId: '97',
    chainName: 'Binance Smart Chain',
    rpcURL: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    chainLogo: '/tokens/bnb.svg',
    explorerURL: {
      home: 'https://testnet.bscscan.com',
      transaction: 'https://testnet.bscscan.com/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'BNB',
        coinMinimalDenom: 'wbnb-wei',
        coinDecimals: 18,
        coinImageUrl: '/tokens/bnb.svg',
        coinGeckoId: 'wbnb',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    chainNetwork: 'testnet',
    type: 'evm',
    chainId: '80001',
    chainName: 'Polygon',
    rpcURL: 'https://polygon-mumbai.api.onfinality.io/public',
    chainLogo: '/tokens/bnb.svg',
    explorerURL: {
      home: 'https://mumbai.polygonscan.com',
      transaction: 'https://mumbai.polygonscan.com/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'MATIC',
        coinMinimalDenom: 'wmatic-wei',
        coinDecimals: 18,
        coinImageUrl: '/tokens/matic.svg',
        coinGeckoId: 'polygon',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
  {
    chainNetwork: 'testnet',
    type: 'evm',
    chainId: '43113',
    chainName: 'Avalanche Fuji',
    rpcURL: 'https://api.avax-test.network/ext/bc/C/rpc',
    chainLogo: '/tokens/avax.svg',
    explorerURL: {
      home: 'https://testnet.snowtrace.io',
      transaction: 'https://testnet.snowtrace.io/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'AVAX',
        coinMinimalDenom: 'wavax-wei',
        coinDecimals: 18,
        coinImageUrl: '/tokens/avax.svg',
        coinGeckoId: 'avalanche',
        isFeeCurrency: true,
        isStakeCurrency: true,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },

  // Mainnets

  {
    chainNetwork: 'mainnet',
    type: 'evm',
    chainId: '0x1',
    chainName: 'Ethereum',
    rpcURL: 'https://1rpc.io/eth',
    chainLogo: '/tokens/eth.svg',
    explorerURL: {
      home: 'https://etherscan.io',
      transaction: 'https://etherscan.io/tx/{transaction}',
    },
    currencies: [
      {
        coinDenom: 'ETH',
        coinMinimalDenom: 'eth-wei',
        coinDecimals: 18,
        coinGeckoId: 'ethereum',
        coinImageUrl: '/tokens/eth.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canWithdraw: false,
        canDeposit: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
      {
        contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        coinDenom: 'USDC',
        coinMinimalDenom: 'uusdc',
        coinDecimals: 6,
        coinGeckoId: 'usd-coin',
        coinImageUrl: '/tokens/usdc.svg',
        isFeeCurrency: false,
        isStakeCurrency: false,
        canSwap: false,
        canDeposit: true,
        /**
         * Disabling Ethereum USDC withdrawals for the time being because
         * withdrarwals must go through Noble first.
         */
        canWithdraw: false,
        canUseLiquidityMining: false,
        canUseLeverageLP: false,
        canUsePerpetual: false,
      },
    ],
  },
] as const satisfies readonly EVMChainInfoDefinition[];

export const EVM_CHAINS = EVM_CHAINS_LIST.reduce(
  (chains, chain) => {
    chains[chain.chainId] = chain as unknown as EVMChainInfo;
    return chains;
  },
  {} as Record<EVMChainId, EVMChainInfo>,
);

export const EVM_ASSETS = Object.values(EVM_CHAINS_LIST)
  .map(chain => {
    return chain.currencies.map(currency => {
      return {
        chainId: chain.chainId,
        chainType: chain.type,
        chainNetwork: chain.chainNetwork,
        ...currency,
      };
    });
  })
  .flat()
  .filter(
    chain => chain.chainNetwork === APP_CONFIG.CHAIN_NETWORK,
  ) as EVMAssetInfo[];

export const EVM_ASSETS_BY_DENOM = EVM_ASSETS.reduce<
  Record<string, EVMAssetInfo>
>((map, asset) => {
  map[asset.coinMinimalDenom] = asset;
  return map;
}, {});
